export default "__VITE_ASSET__FAOlLubT__"